/**
 * Created by CoolGuy on 2017/5/3.
 */

import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
//import CommonAction from './CommonAction';
const {
  ajaxCommon,
  DOMAIN_CURRENT
} = Ajax;
const TheApi = API("permission");

const PERMISSION_USER_AUTH_LIST = "PERMISSION_USER_AUTH_LIST";//获取用户权限列表
const PERMISSION_EDIT = "PERMISSION_EDIT";
const PERMISSION_DETAIL = "PERMISSION_DETAIL";

export default {
    PERMISSION_USER_AUTH_LIST,
    permissionList: ()=>{
        return ajaxCommon({
            api:TheApi('get')(),
            success:(data)=>({
                type:PERMISSION_USER_AUTH_LIST,
                data,
            })
        })
    },
    PERMISSION_EDIT,
    permissionEdit:(userid, list)=>{
        return ajaxCommon({
            api:TheApi('put')(userid),
            data:{
                permissions:list instanceof Array ? list.join(',') : list
            },
            success:(data)=>({
                type:PERMISSION_EDIT,
                data
            })
        })
    },
    PERMISSION_DETAIL,
    permissionDetail:(userid)=>{
        return ajaxCommon({
            api:TheApi('get')(userid),
            success:(data)=>({
                type:PERMISSION_DETAIL,
                data:data
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/PermissionAction.js